export default __webpack_public_path__ + "static/18_months-9565b12c18950f542c7f919dd9ef42fc.jpeg";